// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f765c549","453":"a642394d","455":"cee7f4a8","977":"9002610b"}[chunkId] + ".chunk.js";
};